import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { IEmployerPageSearchCard } from '@app/components/employer-page-search/interfaces/iemployer-page-search-card';
import { ConstantsService } from '@app/services/constants.service';
import { EmployerService } from '@app/services/employer.service';
import { status_code } from 'functions/src/help/status-query';
import SwiperCore, { SwiperOptions, Navigation, Pagination, Autoplay } from 'swiper';

SwiperCore.use([Navigation, Pagination, Autoplay])

@Component({
  selector: 'swiper-home-institution-pro',
  templateUrl: './swiper-home-institution-pro.component.html',
  styleUrls: ['./swiper-home-institution-pro.component.css']
})
export class SwiperHomeInstitutionProComponent implements OnInit {

  public swiperConfig: SwiperOptions = {

    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 0,
    speed: 450,
    autoplay: false,
    loop: false,
    grabCursor: true,

    pagination: {
      el: '#swiper-home-institution-pro',
      clickable: true,
    },
    navigation: {
      nextEl: '#swiper-home-institution-pro-next',
      prevEl: '#swiper-home-institution-pro-prev',
    },
    breakpoints: {
      840: {
        slidesPerView: 2,
        slidesPerGroup : 2
      }
    }
  };

  public isLoadingSearch: boolean = true;
  public data: Array<any> = [];
  @Output() eventSendResume = new EventEmitter<{_idInstitution:number, employerName:string, employerAddress3:string}>();

  constructor(private employerService: EmployerService, public constantsService:ConstantsService) {

  }

  ngOnInit(): void {


    this.isLoadingSearch = true;

    this.employerService.searchInstitutionProHome().toPromise().then(
      res => {

        if (res?.status_code === status_code.success) {
          this.data = res['results'] !== null ? res['results'] : [];
          this.isLoadingSearch = false;
          return;
        }

        this.isLoadingSearch = false;

      },
      err => {
        this.isLoadingSearch = false;
      }
    );
  }

  onClickSendResume(event: MouseEvent, _idInstitution:number, employerName:string, employerAddress3:string) {
    event.preventDefault();
    this.eventSendResume.next({_idInstitution, employerName, employerAddress3})
  }

}
